var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartTrackingArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82031 0.0859375L0.765625 1.16406L8.10156 8.5L0.765625 15.8359L1.82031 16.9141L10.2344 8.5L1.82031 0.0859375ZM7.07031 0.0859375L6.01562 1.16406L13.3516 8.5L6.01562 15.8359L7.07031 16.9141L15.4844 8.5L7.07031 0.0859375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartTrackingArrows);
export default __webpack_public_path__ + "static/media/start_tracking_arrows.327d085886d11dcb4724e4e8a8c50533.svg";
export { ForwardRef as ReactComponent };